import { combineReducers } from "redux";
import * as appSettings from "./applicationReducer";
import * as connections from "./connectionsReducer";
import * as currentProject from "./currentProjectReducer";
import * as appError from "./appErrorReducer";
import * as login from "../../tomcom/login/loginReducer";

/**
 * All application reducers
 * @member appSettings - Application Settings reducer
 * @member connections - Connections reducer
 * @member recentProjects - Recent Projects reducer
 * @member currentProject - Current Project reducer
 */
export default combineReducers({
    appSettings: appSettings.reducer,
    connections: connections.reducer,
    currentProject: currentProject.reducer,
    appError: appError.reducer,
    currentUser: login.reducer
});
